import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, limit, where, getDocs, updateDoc, collection } from "firebase/firestore";
import { db } from "../../firebase";
//import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { NumberFormatter } from '../../components/numberFormatter';
import { Helmet } from "react-helmet";
import Loading from "../../components/loading";
import Loadingimg from '../../components/loadingimg';
import Cookies from 'js-cookie';
import { Randomcode } from '../../components/rendom_code';
import { useToast } from '../../components/ToastContext';
// Icons 
import { MdKeyboardHide, MdManageAccounts } from 'react-icons/md';
import { BiChat } from 'react-icons/bi';
import { VscCalendar } from "react-icons/vsc";
import { GetCalculateAge } from '../../components/calculateAge';
import Photosicon from '../../assets/photos_icon.png';
import { MdOutlinePayments } from "react-icons/md";
import { GetAgoTime } from '../../components/getAgoTime';
import { CiBookmarkCheck, CiBookmark } from "react-icons/ci";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { IoIosArrowForward } from "react-icons/io";
import { FaStar } from "react-icons/fa";
import { BsPersonWorkspace } from "react-icons/bs";
import { IoBusinessOutline, IoDocumentTextOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
//page links 
import Statusbar from '../../master_root/statusbar';
import { Createteam } from './create_team';
import { VscAdd } from 'react-icons/vsc';
import Usersauthorized from './users-authorized';
import { normalize } from 'path-browserify';

export default function Teamroot() {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [UsersData, setUsersData] = useState([]);
  const [adminguid, setadminguid] = useState(Cookies.get("adminguid"));
  const [guid, setGuid] = useState(Cookies.get("guid"));
  const [emailid, setEmailid] = useState();
  const [description, setDescription] = useState();
  const [showUsersauthorized, setShowUsersauthorized] = useState(false);
  //save
  // Save team
  const create_team = async () => {
    if (!emailid.trim() || !description.trim()) {
      showToast("Please enter both Email and description.");
      return;
    }

    setLoading(true);
    try {
      const uid = Randomcode(16); // Fallback for Randomcode
      const result = await Createteam({ uid, emailid, description });

      if (result.success) {
        showToast("Sent successfully");
        setEmailid('');
        setDescription('');
        //  fetchProjectsData(); // Refresh list
      } else {
        showToast("Failed: " + (result.error || "Unknown error"));
      }
    } catch (ex) {
      console.error("An error occurred:", ex);
    } finally {
      setLoading(false);
    }
  };
  //setProjectdata
  useEffect(() => {
    fetchteamUsers();
  }, []);
  const fetchteamUsers = async () => {
    setIsLoading(true);
    console.log("Fetching team users...");

    try {
      // Step 1: Fetch all users added by this admin
      const teamQuery = query(
        collection(db, "projects_users"),
        where("adminguid", "==", adminguid)
      );
      const teamSnapshot = await getDocs(teamQuery);

      if (teamSnapshot.empty) {
        console.log("No team members found.");
        setUsersData([]);
        return;
      }

      // Step 2: Extract all guids from team users
      const teamGuids = teamSnapshot.docs.map(doc => doc.data().guid);

      // Step 3: Fetch full user data for each team member
      const usersQuery = query(
        collection(db, "users"),
        where("guid", "in", teamGuids)
      );
      const usersSnapshot = await getDocs(usersQuery);

      const usersLoginList = usersSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Step 4: For each user, fetch extra details and roles
      const usersWithDetails = await Promise.all(
        usersLoginList.map(async user => {
          // user_details
          const detailsQuery = query(
            collection(db, "users_details"),
            where("guid", "==", user.guid)
          );
          const detailsSnapshot = await getDocs(detailsQuery);
          const userDetails = detailsSnapshot.docs.map(doc => doc.data());

          // authorizedrole
          const roleQuery = query(
            collection(db, "authorizedrole"),
            where("adminguid", "==", Cookies.get("adminguid")),
            where("accountguid", "==", user.guid)
          );
          const roleSnapshot = await getDocs(roleQuery);
          const userRoles = roleSnapshot.docs.map(doc => doc.data());

          return {
            ...user,
            details: userDetails,
            roles: userRoles
          };
        })
      );

      setUsersData(usersWithDetails);
      console.log("Fetched team users with details and roles:", usersWithDetails);

    } catch (error) {
      console.error("Error fetching team users, details, or roles:", error);
    } finally {
      setIsLoading(false);
    }
  };



  //
  function limitStringLength(str, maxLength) {
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + " ..."; // truncate
    }
    return str;
  }
  return (
    <div>
      <Statusbar data={'Owner & Projects manager'} />
      <div className='app_header_height'></div>
      <div className="container_roots">
        <Helmet>
          <title>Find & Post Job Tasks | EditorTask - Connect Users & Editors</title>

          <meta name="description" content="Post or find freelance job tasks on EditorTask. Whether you're an editor or a client, discover and connect with top creative talent across India." />
          <meta name="keywords" content="freelance jobs, creative editors, post tasks, hire talent, remote work, India freelancers, digital jobs, EditorTask platform" />
          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />

          <meta property="og:title" content="Find & Post Job Tasks | EditorTask - Connect Users & Editors" />
          <meta property="og:description" content="EditorTask helps users post tasks and hire editors across India. Editors can explore and apply for freelance opportunities in creative industries." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.editortask.com/jobs" />
          <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
        </Helmet>

        <div className="container_size">

          <div className='post-container'>
            <div className='post_div'>
              <div className="editorsui-grid">
                {isLoading ? (
                  <Loading /> // 🔁 Is this a typo? Should it be <Loading />?
                ) : (
                  <>
                    {Array.isArray(UsersData) && UsersData.length > 0 ? (
                      UsersData.map((userlist, index) => (
                        <div
                          style={{ cursor: 'default' }}
                          className="editor-items"
                          key={index}
                        >
                          <div className='photo-ui-body' >
                            <div className='cover-ui-div'>
                              {loading && <div className="loading"><Loading /></div>}
                              <img
                                className="user-ui-covers-img"
                                src={userlist.cover}
                                alt="cover"
                                onLoad={() => setLoading(false)}
                                onError={() => setLoading(false)} // also hides loader if there's an error
                                style={{ display: loading ? 'none' : 'block' }} // hide img while loading
                              />
                            </div>
                            <div className='photo-ui-div'>
                              <img
                                className='photo-ui-img'
                                src={userlist.photoURL}
                                alt="User"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = Photosicon;
                                }}
                              />
                            </div>
                          </div>
                          <div className='name-div'>
                            <div className='subscriber-btn'><b>{userlist.subscriber}</b> Subscriber</div>

                            <div className="name-text" >
                              {userlist.name}
                            </div>
                            <div className="bio-text" >
                              {limitStringLength(userlist.bio, 40)}
                            </div>
                            <br />
                          </div>
                          <div className='editor-div'>
                            <table className='editor-table' >
                              <tr><td>
                                <LuBriefcaseBusiness className='eicon' />
                              </td>
                                <td>

                                  <td className='iteme-text'>
                                    {`${GetCalculateAge(userlist?.work_experience)} Yrs Experience`}
                                  </td>
                                </td>
                              </tr>
                              <tr><td>
                                <VscCalendar className='eicon' />
                              </td>
                                <td className='iteme-text'>
                                  {`Age: ${GetCalculateAge(userlist?.dob)} Years`}
                                </td>
                              </tr>
                              {/* <tr><td>
                                <MdOutlinePayments className='icon' />
                              </td>
                              <td>
                              {userlist.details.map((detail, index) => (
                                <a className='iteme-text' key={index}>{JSON.stringify(detail)}</a>                                
                              ))}
                             </td>
                               
                              </tr> */}

                              {userlist.country !== "no" && (
                                <tr>
                                  <td>
                                    <CiLocationOn className='eicon' />
                                  </td>
                                  <td>
                                    <a className='iteme-text'>{userlist.country}</a>
                                  </td>
                                </tr>

                              )}
                              <tr><td>
                                <VscCalendar className='eicon' />
                              </td>
                                <td className='iteme-text'>
                                  {`Join:  ${GetAgoTime(userlist.datetime)} `}
                                </td>
                              </tr>
                            </table>
                          </div>
                          <div className='contact-us-div' style={{ borderTop: `solid 2px ${userlist.roles[0]?.color}` }}>
                            <div className='contact-btn'>
                              <div onClick={() => setShowUsersauthorized(true)} className='button-ui4'><MdManageAccounts className='icon' /><b>Permissions</b></div>
                            </div>
                            {userlist.roles.length > 0 ? (

                              userlist.roles.map((role, i) => (
                                <p className='iteme-text' style={{ textTransform: 'capitalize' }} key={i}>Role:<b> {role.permissions || "No permissions"}</b></p>
                              ))


                            ) : (
                              <p>No authorized roles</p>
                            )}
                            <div className='contact-btn'>
                              <div onClick={() => setShowUsersauthorized(true)} className='button-ui'> {userlist.roles[0]?.rolename || "Manager Role"}</div>

                              {showUsersauthorized && (
                                <Usersauthorized data={userlist} onClose={() => setShowUsersauthorized(false)} />
                              )}
                            </div>

                          </div>
                          <div className='contact-us-div'>

                            <div className='contact-btn'>
                              <div onClick={() => navigate(`/${userlist.slug}`)} className='button-ui1'> <BiChat className='icon' /> Contact Us</div>
                            </div>

                          </div>

                        </div>
                      ))
                    ) : (

                      <p>No Developers found.</p>
                    )}
                  </>
                )}
              </div>



            </div>
            <div className='post_updates'>
              <div className="contact-title">Add new Account</div>
              <table>
                <tr>
                  <td><input placeholder='Email id' maxLength={100} className='projects-input-box' onChange={(e) => setEmailid(e.target.value)}></input></td>
                </tr>
                <tr>
                  <td><textarea className='projects-input-box' maxLength={200} placeholder='Description' onChange={(e) => setDescription(e.target.value)}></textarea></td>
                </tr>
                <tr>
                  <td>
                    <div className='button-ui' onClick={create_team}  ><VscAdd className='icon' /> Create</div>
                  </td>
                </tr>
              </table>

            </div>
          </div>

        </div>

      </div>
    </div>
  );
}
